module.exports = __webpack_public_path__ + "img/i15.fde2fc30.svg";